import React, { Component } from 'react';

import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsCategoryObjectBlock extends Component {
  createdAt = new Date();

  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">The category object</div>
          <APIDocsTable
            title="Attributes"
            rows={[
              {
                description: 'A unique identifier for the category.',
                heading: 'id',
                subheading: 'string',
              },
              {
                description: 'The board this category is associated with.',
                heading: 'board',
                subheading: 'Board object',
              },
              {
                description: 'Time at which the category was created, in ISO 8601 format.',
                heading: 'created',
                subheading: 'string',
              },
              {
                description: 'The name of the category.',
                heading: 'name',
                subheading: 'string',
              },
              {
                description:
                  'The id of the parent category. If this category is not a sub category, this field will be null.',
                heading: 'parentID',
                subheading: 'string',
              },
              {
                description: 'The number of posts that have been assigned this category.',
                heading: 'postCount',
                subheading: 'number',
              },
              {
                description:
                  'The URL to the board, filtered to just posts that have been assigned this category.',
                heading: 'url',
                subheading: 'string',
              },
            ]}
          />
        </div>
        <div>
          <div className="text">Example category object:</div>
          <Highlight lang="json">
            {`{
  "id": "553c3ef8b8cdcd1501ba12bb",
  "board": {
    "created": "${this.createdAt.toISOString()}",
    "id": "553c3ef8b8cdcd1501ba4400",
    "name": "Feature Requests",
    "postCount": 99,
    "url": "https://your-company.canny.io/admin/board/feature-requests"
  },
  "created": "${this.createdAt.toISOString()}",
  "name": "Example Category Name",
  "parentID": "552c3ef8b8cdcd1501ba12bb",
  "postCount": 12,
  "url": "https://your-company.canny.io/admin/board/feature-requests?category=example-category-name"
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
